import {BaseCachedService} from './Core/BaseCachedService';

class StakeholderTypeService extends BaseCachedService {
    get ModelName() { return "Contact Type"; }
    get PrimaryKeyProperty() { return "stakeholderTypeId"; }
    get Url() { return super.Url + "/stakeholderType"; }

}

export const service = new StakeholderTypeService();

